import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { SupportingEvidenceFlow, TicketNumberFlow } from '../../pageFlowData'
import { data } from './data'
import styles from './SupportingEvidence.module.scss'

export const SupportingEvidence: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    issue: { supportingEvidence },
  } = state

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_SUPPORTING_EVIDENCE', data: value })
    dispatch({ type: 'UPDATE_STEP', data: TicketNumberFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: TicketNumberFlow.PROGRESS_VALUE })
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${SupportingEvidenceFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleSubmit = (id: string) => {
    handleDispatch(id)
    handleTracking(id)
  }

  const { buttons, imgObj, title } = data

  return (
    <div data-testid="supporting-evidence">
      <PillButtonPage
        buttons={buttons}
        defaultValue={supportingEvidence}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        infoBoxData={data}
        pillButtonGroupStyle={styles.supportingEvidencePagePillButtons}
        title={title}
      />
    </div>
  )
}
